<template>
  <section>
    <div class="mx-2 mt-3 mb-2 rounded-lg">
      <div class="flex mb-5 justify-center bg-white rounded-lg">
        <div
          class="px-2 pb-1 mt-3 -mb-3 mx-3 self-center text-center whitespace-normal text-2xl sm:text-4xl text-white bg-green-600/75  backdrop-blur-xs border border-white rounded-lg"
        >
          Cookies / Informasjonskapsler
        </div>
      </div>
    </div>
    <article class="prose mx-2 mt-3 px-3 pt-3 pb-12 bg-white rounded-lg">
      <h2 id="bruk-av-informasjonskapsler">Bruk av informasjonskapsler</h2>
      <p>
        Bede.no benytter kun funksjonelle informasjonskapsler som er nødvendige
        for å tilby tjenesten. Informasjonskapslene benyttes til innlogging, for
        å luke bort roboter og spam og til å huske filtreringen du har valgt for
        programoversikten. Bede.no kjører på Firebase/Google Cloud Platform.
        Derfor oppfyller vi kravene fremsatt av Google for
        <BedeLink
          to="https://www.google.com/about/company/user-consent-policy/"
          :external="true"
        >
          brukerorientering og brukersamtykke </BedeLink
        >. Merk at Bede.no ikke benytter analyseverktøy eller
        markedsføringsverktøy.
      </p>
      <h3>Informasjonskapsler vi benytter</h3>
      <ul>
        <li>
          <b>Innloggingsidentifikator</b> fra
          <BedeLink
            to="https://firebase.google.com/products/auth/"
            :external="true"
          >
            Firebase Authentication
          </BedeLink>
          <p>
            En unik id som gjør at autentiseringsløsningen kan identifisere deg
            og gi deg tilgang til riktig innhold.
          </p>
        </li>
        <li>
          <b>Midlertidig nøkkel</b> fra
          <BedeLink
            to="https://firebase.google.com/products/auth/"
            :external="true"
          >
            Firebase Authentication
          </BedeLink>
          <p>
            En unik midlertidig nøkkel som gjør at du autentiseringsløsningen
            kan bekrefte at du er innlogget på tvers av sidevisninger.
          </p>
        </li>
        <li>
          <b>Attestering</b> fra
          <BedeLink
            to="https://firebase.google.com/products/app-check/"
            :external="true"
          >
            Firebase App Check
          </BedeLink>
          <p>
            En unik nøkkel fra App Check som bekrefter at du er å anse som en
            trygg besøkende.
          </p>
        </li>
        <li>
          <b>Filtreringsregler</b>
          <p>
            En samling av regler for hvilke arrangement som skal vises i
            programoversikten basert på lokasjon, arrangør, aktivitetstype,
            aldersgruppe osv.
          </p>
        </li>
        <li>
          <b>Cookie-bekreftelse</b>
          <p>
            Et merke på at du har klikket "Ok" på informasjonskapsel-banneret,
            slik at vi ikke trenger å vise det lenger. Du kan slette denne
            bekreftelsen nederst på denne siden.
          </p>
        </li>
      </ul>
      <h2>Blokkering av informasjonskapsler</h2>
      <p>
        Dersom du ønsker å reservere deg mot bruk av informasjonskapsler, kan du
        endre innstillinger i nettleseren din slik at informasjonskapslene blir
        blokkert. Du finner instruksjoner nedenfor.
      </p>
      <ul>
        <li>
          <BedeLink
            to="https://support.google.com/chrome/answer/95647"
            :external="true"
          >
            Chrome
          </BedeLink>
        </li>
        <li>
          <BedeLink
            to="https://support.microsoft.com/search/results?query=block+cookies"
            :external="true"
          >
            Microsoft Edge
          </BedeLink>
        </li>
        <li>
          <BedeLink
            to="https://support.apple.com/en-us/HT201265"
            :external="true"
          >
            Apple Safari (iOS)
          </BedeLink>
        </li>
        <li>
          <BedeLink
            to="https://support.apple.com/guide/safari/manage-cookies-sfri11471/mac"
            :external="true"
          >
            Apple Safari (Mac)
          </BedeLink>
        </li>
        <li>
          <BedeLink
            to="https://support.mozilla.org/en-US/kb/block-websites-storing-cookies-site-data-firefox"
            :external="true"
          >
            Mozilla Firefox
          </BedeLink>
        </li>
        <li>
          <BedeLink
            to="https://help.opera.com/en/latest/web-preferences/#cookies"
            :external="true"
          >
            Opera
          </BedeLink>
        </li>
      </ul>
      <h2>Trekke tilbake bekreftelse</h2>
      <p>
        Dersom du ønsker trekke tilbake bekreftelsen på at du tillater at vi
        bruker funksjonelle informasjonskapsler, kan du gjøre det her.
      </p>
      <button
        class="m-auto p-2 text-white bg-green-600 hover:bg-green-500 focus:bg-green-500 active:bg-blue-gray-700 rounded-md"
        @click="withdraw()"
      >
        Trekk tilbake bekreftelsen
      </button>
    </article>
  </section>
</template>

<script setup lang="ts">
const cookieConsentState = useCookieConsent();
const withdraw = () => {
  cookieConsentState.value = "";
};

onMounted(() => window.scrollTo(0, 0));
</script>
